export default __webpack_public_path__ + "static/Lilly2-59c58cd59944ba4f0ccadb3b7dca7ff9.jpg";